export const COLORS = {
  WHITE_1: '#fff',
  BLACK_1: '#1e1e2d',
  BLACK_2: '#2b2b40',
  BLACK_3: '#1b1b28',
  GRAY_1: '#cdcdde',
  GRAY_2: '#474761',
  BLUE_1: '#3699ff',
  BLUE_2: '#DAF1FC',
  BLUE_3: '#5C94CE',
  RED_1: '#BF3011',
};

export const SCREEN = {
  min: 500,
  max: 1024,
};

export const MAX_SCREEN = 1440;
